function qsa(sel, root) {
  return Array.prototype.slice.call((root || document).querySelectorAll(sel));
}

function normalizeSiteLabel(site) {
  if (!site) return '外部サイト';
  var lower = site.toString().toLowerCase();
  if (lower === 'greensite' || lower === 'グリーンサイト') return 'グリーンサイト';
  if (lower === 'buildy' || lower === 'ビルディ') return 'ビルディ';
  return site;
}

function escapeHtml(v) {
  var s = v == null ? '' : v.toString();
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function buildDiffTable(siteLabel, externalLastUpdated, lapriLastUpdated, changes) {
  if (!changes || changes.length === 0) {
    return '<p>差分はありません。</p>';
  }

  var html = '<table class="ui celled table compact small">';
  html += '<thead><tr>';
  html += '<th>項目</th>';
  html += '<th>LAPRIの値</th>';
  html += '<th>' + siteLabel + 'の値</th>';
  html += '</tr></thead><tbody>';

  changes.forEach(function (c, idx) {
    var fieldLabel = escapeHtml(c.label || c.field || '');
    var tooltip = c.tooltip ? escapeHtml(c.tooltip) : '';
    var lapriVal = escapeHtml(c.lapri_value != null ? c.lapri_value : '');
    var extVal = escapeHtml(c.external_value != null ? c.external_value : '');
    var lapriUpdatable = c.lapri_updatable !== false;

    var tooltipHtml = tooltip
      ? ' <span class="diff-tooltip-icon" data-tooltip="' + tooltip + '" data-position="top center" style="display:inline-flex;align-items:center;justify-content:center;width:16px;height:16px;border-radius:50%;background:#888;color:#fff;font-size:11px;font-weight:bold;cursor:help;vertical-align:middle;margin-left:4px;" title="' + tooltip + '">?</span>'
      : '';

    html += '<tr>';
    html += '<td>' + fieldLabel + tooltipHtml + '</td>';
    if (lapriUpdatable) {
      html += '<td class="js-worker-diff-choice worker-diff-choice" data-row="' + idx + '" data-source="lapri" tabindex="0">' + lapriVal + '</td>';
    } else {
      html += '<td class="worker-diff-choice worker-diff-not-updatable" title="LAPRIの値を' + siteLabel + 'に反映できない項目です">' + lapriVal + '</td>';
    }
    html += '<td class="js-worker-diff-choice worker-diff-choice" data-row="' + idx + '" data-source="external" tabindex="0">' + extVal + '</td>';
    html += '</tr>';
  });

  html += '</tbody></table>';

  if (externalLastUpdated || lapriLastUpdated) {
    html += '<div class="ui message small" style="margin-top:0.5em;">';
    if (lapriLastUpdated) html += '<p>LAPRI最終更新: ' + lapriLastUpdated + '</p>';
    if (externalLastUpdated) html += '<p>' + siteLabel + '最終更新: ' + externalLastUpdated + '</p>';
    html += '</div>';
  }

  return html;
}

function buildHistoryTable(changes) {
  if (!changes || changes.length === 0) {
    return '<p>変更履歴はありません。</p>';
  }

  var html = '<table class="ui celled table compact small">';
  html += '<thead><tr><th>項目</th><th>変更前</th><th>変更後</th></tr></thead><tbody>';

  changes.forEach(function (c) {
    html += '<tr>';
    html += '<td>' + escapeHtml(c.label || c.field || '') + '</td>';
    html += '<td>' + escapeHtml(c.old_value != null ? c.old_value : '') + '</td>';
    html += '<td>' + escapeHtml(c.new_value != null ? c.new_value : '') + '</td>';
    html += '</tr>';
  });

  html += '</tbody></table>';
  return html;
}

// 関連フィールドグループ定義: GS側で連動する必須項目のみグループ化
// 有効期限・番号など単独更新可能な項目はグループに含めない
var LINKED_FIELD_GROUPS = [
  ["健康保険", "健康保険加入予定年月", "健康保険組合"],
  ["年金保険", "年金保険種別", "年金保険加入予定年月"],
  ["雇用保険加入状況", "雇用保険加入予定年月", "雇用保険被保険者番号（下4桁）"],
  ["退職金共済", "共済加入状況"]
];

// 労災グループ: 労災保険特別加入 が差分に含まれる場合のみ関連項目を連動選択
// それ以外の項目（関係区分・詳細・番号・整理番号・有効期限）のみの差分なら個別選択可
// 雇用形態 は GS 側 radio (一人親方) との関係で別条件のため、このグループから除外し個別選択にする
var ROSAI_ALL_FIELDS = ["労災保険特別加入", "労災関係区分", "労災関係詳細", "労災保険番号", "整理番号", "特別加入有効期限"];
var ROSAI_PARENT_FIELDS = ["労災保険特別加入"];

// ビルディ（LAPRI→ビルディ方向）用グループ定義。
// Rpa::BuildeeDiffApplier::INTERDEPENDENT_LABEL_GROUPS の健康保険/年金保険/雇用保険と対応させる。
// バックエンド側（expand_with_group_status_labels）は、グループ内のどれか1項目を選択すれば
// 同グループで実際に差分がある他の項目も一緒に連携するが、この見た目側の連動選択が無いと
// 「1項目しか選んでいないように見えるのに他の項目も連携される」という見た目と実態の不一致が
// 起きるため、GSと同じ仕組みで見た目上も連動させる。GSと異なり、ビルディは加入予定年月・
// 有効期限・番号もバックエンドで同時反映するため、これらもグループに含める。
var BUILDEE_LINKED_FIELD_GROUPS = [
  ["健康保険", "健康保険組合", "健康保険加入予定年月", "健康保険有効期限"],
  ["年金保険", "年金保険種別", "年金保険加入予定年月", "年金保険有効期限"],
  ["雇用保険加入状況", "雇用保険加入予定年月", "雇用保険被保険者番号（下4桁）"],
  ["退職金共済", "被共済番号"]
];

function bindDiffChoiceInteractions(bodyEl, changesRef, siteRef) {
  if (!bodyEl) return;

  // 行のラベルからグループ内の他の行番号を取得
  function getLinkedRows(rowIdx) {
    var changes = changesRef();
    if (!changes || !changes[rowIdx]) return [];
    var label = changes[rowIdx].label || '';
    var isBuildee = siteRef && siteRef() === 'ビルディ';
    var linkedGroups = isBuildee ? BUILDEE_LINKED_FIELD_GROUPS : LINKED_FIELD_GROUPS;

    // 通常の固定グループをチェック
    for (var g = 0; g < linkedGroups.length; g++) {
      if (linkedGroups[g].indexOf(label) === -1) continue;
      var rows = [];
      for (var i = 0; i < changes.length; i++) {
        if (i === rowIdx) continue;
        var cl = changes[i].label || '';
        if (linkedGroups[g].indexOf(cl) !== -1) {
          rows.push(i);
        }
      }
      return rows;
    }

    // 労災グループ: ビルディはバックエンド側で関係区分等を同時反映しないため対象外
    // （更新APIに対応フィールドが存在しない項目のため、見た目だけ連動させても意味が無い）。
    if (!isBuildee && ROSAI_ALL_FIELDS.indexOf(label) !== -1) {
      var hasParent = false;
      for (var i = 0; i < changes.length; i++) {
        var cl = changes[i].label || '';
        if (ROSAI_PARENT_FIELDS.indexOf(cl) !== -1) {
          hasParent = true;
          break;
        }
      }
      if (hasParent) {
        // 親フィールドが差分にある → 全項目連動
        var rows = [];
        for (var i = 0; i < changes.length; i++) {
          if (i === rowIdx) continue;
          var cl = changes[i].label || '';
          if (ROSAI_ALL_FIELDS.indexOf(cl) !== -1) {
            rows.push(i);
          }
        }
        return rows;
      }
      // 親フィールドなし → 個別選択可（リンクなし）
      return [];
    }

    return [];
  }

  function toggleSelection(target) {
    var row = parseInt(target.dataset.row, 10);
    var source = target.dataset.source;
    var alreadySelected = target.classList.contains('is-selected');
    // 同じ行の他セルをクリア
    qsa('.js-worker-diff-choice[data-row="' + row + '"]', bodyEl).forEach(function (el) {
      el.classList.remove('is-selected');
    });
    if (!alreadySelected) {
      target.classList.add('is-selected');
      // 関連フィールドを同じソースで自動選択
      var linked = getLinkedRows(row);
      linked.forEach(function (linkedRow) {
        // 同じソースのセルを選択（存在する場合のみ）
        var sameSrcCell = bodyEl.querySelector(
          '.js-worker-diff-choice[data-row="' + linkedRow + '"][data-source="' + source + '"]'
        );
        if (sameSrcCell) {
          qsa('.js-worker-diff-choice[data-row="' + linkedRow + '"]', bodyEl).forEach(function (el) {
            el.classList.remove('is-selected');
          });
          sameSrcCell.classList.add('is-selected');
        }
      });
    } else {
      // 選択解除時は関連フィールドも解除
      var linked = getLinkedRows(row);
      linked.forEach(function (linkedRow) {
        qsa('.js-worker-diff-choice[data-row="' + linkedRow + '"]', bodyEl).forEach(function (el) {
          el.classList.remove('is-selected');
        });
      });
    }
  }

  bodyEl.addEventListener('click', function (e) {
    var target = e.target && e.target.closest ? e.target.closest('.js-worker-diff-choice') : null;
    if (!target || !bodyEl.contains(target)) return;
    toggleSelection(target);
  });

  bodyEl.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var target = e.target && e.target.closest ? e.target.closest('.js-worker-diff-choice') : null;
    if (!target || !bodyEl.contains(target)) return;
    e.preventDefault();
    toggleSelection(target);
  });
}

function setupWorkerExternalSiteSyncModal(root) {
  root = root || document;
  var $ = window.jQuery;

  var modalEl = root.getElementById('worker-external-site-sync-modal');
  if (!modalEl) return;

  var titleEl = modalEl.querySelector('[data-worker-external-site-modal="title"]');
  var bodyEl = modalEl.querySelector('[data-worker-external-site-modal="body"]');

  var currentTriggerEl = null;
  var currentChanges = [];
  var currentSiteLabel = '';
  var currentExternalLastUpdated = '';
  var currentLapriLastUpdated = '';
  var currentWorkerId = null;
  var currentApplyUrl = null;

  bindDiffChoiceInteractions(bodyEl, function () { return currentChanges; }, function () { return currentSiteLabel; });

  var applyButton = modalEl.querySelector('[data-worker-external-site-modal="apply"]');
  if (applyButton && applyButton.dataset.bound !== '1') {
    applyButton.dataset.bound = '1';
    applyButton.addEventListener('click', function () {
      // If no diff context, just close
      if (!currentWorkerId) {
        if ($ && $.fn && $.fn.modal) {
          $(modalEl).modal('hide');
        } else {
          modalEl.style.display = 'none';
        }
        return;
      }

      // 選択された行からラベルとソース（lapri/external）を収集
      var selected = qsa('.js-worker-diff-choice.is-selected', bodyEl).map(function (el) {
        var row = parseInt(el.dataset.row, 10);
        var src = el.dataset.source;
        var change = currentChanges && currentChanges[row];
        if (!change) return null;
        return { label: change.label, source: src, lapri_value: change.lapri_value };
      }).filter(Boolean);

      if (selected.length === 0) {
        if ($ && $.fn && $.fn.modal) {
          $(modalEl).modal('hide');
        } else {
          modalEl.style.display = 'none';
        }
        return;
      }

      // 氏名・氏名カナでLAPRIの値を選択した場合、半角文字チェック
      // グリーンサイトは全角文字のみ登録可能という制約があるための検証であり、ビルディ等他サイトには適用しない
      var HALFWIDTH_RE = /[a-zA-Z0-9!-\/:-@\[-`{-~]/;
      var fieldErrors = currentSiteLabel !== 'グリーンサイト' ? [] : selected.filter(function (sel) {
        if (sel.source !== 'lapri') return false;
        if (sel.label !== '氏名' && sel.label !== '氏名カナ' && sel.label !== '緊急連絡先名' && sel.label !== '緊急連絡先住所') return false;
        return HALFWIDTH_RE.test(sel.lapri_value || '');
      });

      if (fieldErrors.length > 0) {
        var errHtml = '<div class="ui error message" style="margin:1em 0;">';
        errHtml += '<div class="header">グリーンサイトに連携できない文字が含まれています</div>';
        errHtml += '<ul class="list">';
        fieldErrors.forEach(function (sel) {
          if (sel.label === '氏名カナ') {
            errHtml += '<li>「氏名カナ」に英字・半角文字が含まれています。グリーンサイトでは全角カナのみ登録可能です（数字・記号・半角文字は使えません）。LAPRIの値をカタカナに修正してから再度お試しください。</li>';
          } else {
            errHtml += '<li>「' + escapeHtml(sel.label) + '」に半角文字が含まれています。グリーンサイトでは全角文字のみ使用できます。LAPRIの値を全角に修正してから再度お試しください。</li>';
          }
        });
        errHtml += '</ul>';
        errHtml += '</div>';
        if (bodyEl) {
          var existing = bodyEl.querySelector('.ui.error.message');
          if (existing) existing.parentNode.removeChild(existing);
          bodyEl.insertAdjacentHTML('afterbegin', errHtml);

          var newFieldErrEl = bodyEl.querySelector('.ui.error.message');
          if (newFieldErrEl && newFieldErrEl.scrollIntoView) {
            newFieldErrEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
        return;
      }

      applyButton.classList.add('loading');
      applyButton.classList.add('disabled');

      // CSRFトークンを取得してRails側の apply_*_diffs へPOST
      // （どのエンドポイントを呼ぶかはトリガー要素の data-apply-url で指定。未指定時はグリーンサイト用にフォールバック）
      var tokenEl = document.querySelector('meta[name="csrf-token"]');
      var csrfToken = tokenEl ? tokenEl.getAttribute('content') : null;
      var applyUrl = currentApplyUrl || ('/workers/' + currentWorkerId + '/apply_greensite_diffs');

      function clearApplyLoading() {
        applyButton.classList.remove('loading');
        applyButton.classList.remove('disabled');
      }

      // ビルディは反映を非同期ジョブで実行するため、processing + poll_url が返る。その場合は
      // 完了までポーリングする（グリーンサイトは従来どおり同期レスポンスを直接描画するため無関係）。
      function pollBuildeeApply(pollUrl, attempt) {
        attempt = attempt || 0;
        if (attempt > 120) { // 5秒 × 120 = 10分でタイムアウト
          clearApplyLoading();
          window.alert('反映がタイムアウトしました。時間をおいて状況をご確認ください。');
          return;
        }
        window.fetch(pollUrl, {
          method: 'GET',
          headers: { 'Accept': 'application/json', 'X-CSRF-Token': csrfToken },
          credentials: 'same-origin'
        }).then(function (res) {
          return res.json().then(function (json) { return { ok: res.ok, status: res.status, json: json }; });
        }).then(function (payload) {
          var st = (payload.json && payload.json.status) || '';
          if (st === 'done') {
            renderApplyResult({ ok: true, status: 200, json: payload.json });
            clearApplyLoading();
          } else if (st === 'none') {
            clearApplyLoading();
          } else {
            setTimeout(function () { pollBuildeeApply(pollUrl, attempt + 1); }, 5000);
          }
        }).catch(function () {
          setTimeout(function () { pollBuildeeApply(pollUrl, attempt + 1); }, 5000);
        });
      }

      function renderApplyResult(payload) {
        var json = payload.json || {};
        if (!payload.ok || json.ok === false) {
          // エラー結果をモーダル内に表示（スクリーンショットURLはクリック可能リンクにする）
          var errorHtml = '<div class="ui error message" style="margin:1em 0;">';
          errorHtml += '<div class="header">' + escapeHtml(json.message || '更新に失敗しました') + '</div>';
          if (json.errors && json.errors.length > 0) {
            errorHtml += '<ul class="list">';
            json.errors.forEach(function (e) {
              var label = e.label ? escapeHtml(e.label) + ': ' : '';
              var errText = escapeHtml(e.error || '');
              errorHtml += '<li>' + label + errText;
              if (e.screenshot_url) {
                errorHtml += ' <a href="' + escapeHtml(e.screenshot_url) + '" target="_blank" rel="noopener noreferrer" class="ui mini basic red label" style="margin-left:0.5em;">スクリーンショット</a>';
              }
              errorHtml += '</li>';
            });
            errorHtml += '</ul>';
          }
          errorHtml += '</div>';
          if (bodyEl) {
            // エラーメッセージを差分テーブルの上に表示（テーブルは残す）
            var existingErr = bodyEl.querySelector('.ui.error.message');
            if (existingErr) existingErr.parentNode.removeChild(existingErr);

            // remaining_changesがあれば差分テーブルも更新（エラー + テーブル両方表示）
            var remaining = json.remaining_changes;
            if (remaining && remaining.length > 0) {
              currentChanges = remaining;
              bodyEl.innerHTML = errorHtml + buildDiffTable(currentSiteLabel, currentExternalLastUpdated, currentLapriLastUpdated, currentChanges);
            } else {
              // remaining_changesがない場合、既存テーブルを保持してエラーを上に追加
              var existingTable = bodyEl.querySelector('table');
              if (existingTable) {
                bodyEl.insertAdjacentHTML('afterbegin', errorHtml);
              } else {
                bodyEl.innerHTML = errorHtml;
              }
            }

            // 差分行数が多いとエラーがモーダル上部に隠れて見えないため、表示位置までスクロールする
            var newErrEl = bodyEl.querySelector('.ui.error.message');
            if (newErrEl && newErrEl.scrollIntoView) {
              newErrEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
          return;
        }

        currentChanges = json.remaining_changes || [];

        if (bodyEl) bodyEl.innerHTML = buildDiffTable(currentSiteLabel, currentExternalLastUpdated, currentLapriLastUpdated, currentChanges);

        // Update trigger data so reopen shows latest state
        if (currentTriggerEl) {
          currentTriggerEl.dataset.changes = JSON.stringify(currentChanges || []);
        }

        if (!json.has_difference) {
          // Remove the yellow diff block if it exists
          if (currentTriggerEl) {
            var msg = currentTriggerEl.closest ? currentTriggerEl.closest('.ui.message') : null;
            if (msg && msg.parentNode) msg.parentNode.removeChild(msg);
          }

          // Close modal
          if ($ && $.fn && $.fn.modal) {
            $(modalEl).modal('hide');
          } else {
            modalEl.style.display = 'none';
          }
        }
      }

      window.fetch(applyUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        credentials: 'same-origin',
        body: JSON.stringify({ selections: selected })
      }).then(function (res) {
        return res.json().then(function (json) { return { ok: res.ok, status: res.status, json: json }; });
      }).then(function (payload) {
        var json = payload.json || {};
        // ビルディは非同期反映: processing + poll_url ならポーリングへ切り替え（ローディング維持）。
        // グリーンサイト等の同期レスポンスはそのまま描画する。
        if (payload.ok && json.status === 'processing' && json.poll_url) {
          pollBuildeeApply(json.poll_url, 0);
          return;
        }
        renderApplyResult(payload);
        clearApplyLoading();
      }).catch(function (err) {
        window.alert('更新に失敗しました: ' + (err && err.message ? err.message : err));
        clearApplyLoading();
      });
    });
  }

  // 差分を見る（選択式）
  qsa('.js-worker-external-site-operation', root).forEach(function (el) {
    if (el.dataset.bound === '1') return;
    el.dataset.bound = '1';

    el.addEventListener('click', function (e) {
      e.preventDefault();

      var site = el.dataset.site || '';
      var siteLabel = normalizeSiteLabel(site);
      var externalLastUpdated = (el.dataset.lastUpdated || '').toString();
      var lapriLastUpdated = (el.dataset.lapriLastUpdated || '').toString();
      var workerId = el.dataset.workerId || null;
      var applyUrl = el.dataset.applyUrl || null;
      var changes = [];
      try {
        changes = JSON.parse(el.dataset.changes || '[]');
      } catch (_) {
        changes = [];
      }

      currentTriggerEl = el;
      currentChanges = changes || [];
      currentSiteLabel = siteLabel;
      currentExternalLastUpdated = externalLastUpdated;
      currentLapriLastUpdated = lapriLastUpdated;
      currentWorkerId = workerId;
      currentApplyUrl = applyUrl;

      if (titleEl) titleEl.textContent = siteLabel + 'の差分内容';
      if (bodyEl) bodyEl.innerHTML = buildDiffTable(siteLabel, externalLastUpdated, lapriLastUpdated, changes);

      // ビルディへの更新は現在有効化済み（旧安全策はコメントアウトで保持）。
      // if (applyButton) applyButton.style.display = (siteLabel === 'ビルディ') ? 'none' : '';
      if (applyButton) applyButton.style.display = '';

      if ($ && $.fn && $.fn.modal) {
        $(modalEl).modal('show');
      } else {
        modalEl.style.display = 'block';
      }
    });
  });

  // 情報更新（従来の表示）
  qsa('.js-worker-external-site-history', root).forEach(function (el) {
    if (el.dataset.bound === '1') return;
    el.dataset.bound = '1';

    el.addEventListener('click', function (e) {
      e.preventDefault();

      var site = (el.dataset.site || '').toString();
      var changes = [];
      try {
        changes = JSON.parse(el.dataset.changes || '[]');
      } catch (_) {
        changes = [];
      }

      if (titleEl) titleEl.textContent = '作業員 変更内容（' + site + '）';
      if (bodyEl) bodyEl.innerHTML = buildHistoryTable(changes);

      if (applyButton) applyButton.style.display = 'none';

      if ($ && $.fn && $.fn.modal) {
        $(modalEl).modal('show');
      } else {
        modalEl.style.display = 'block';
      }
    });
  });
}

$(function () {
  setupWorkerExternalSiteSyncModal(document);
});
